// extracted by mini-css-extract-plugin
export default {"container":"LPIP6bThUKDgKOu8F4sV-w==","content":"U96x+mjaZvX-ZXho1i8ukg=="};